import { AxiosRequestConfig } from 'axios';
import API from '../API';
import CustomerRelation from '../../models/CustomerRelation';

export const getRepresentativesForCustomer = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest('/representative', queryParams, options) as Promise<CustomerRelation[]>;

export const saveRepresentative = (
  body: Partial<CustomerRelation>,
  options: AxiosRequestConfig = {},
) => API.makePostRequest('/representative', body, options);

export const editRepresentative = (
  body: Partial<CustomerRelation>,
  options: AxiosRequestConfig = {},
) => API.makePatchRequest('/representative', body, {}, options);

export const deleteRepresentative = (pathParams: { relationId: number }) =>
  API.makeDeleteRequest(`/representative/${pathParams.relationId}`, {});
